import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StockMovements = ({ movements = [], onBack }) => {
  const getMovementTypeConfig = (type) => {
    const configs = {
      purchase: {
        label: 'Compra',
        icon: 'ShoppingCart',
        color: 'success',
        bgColor: 'bg-success-100',
        textColor: 'text-success-700'
      },
      sale: {
        label: 'Venta',
        icon: 'TrendingDown',
        color: 'primary',
        bgColor: 'bg-primary-100',
        textColor: 'text-primary-700'
      },
      adjustment: {
        label: 'Ajuste',
        icon: 'Settings',
        color: 'warning',
        bgColor: 'bg-warning-100',
        textColor: 'text-warning-700'
      },
      adjustment_in: {
        label: 'Ajuste +',
        icon: 'TrendingUp',
        color: 'success',
        bgColor: 'bg-success-100',
        textColor: 'text-success-700'
      },
      adjustment_out: {
        label: 'Ajuste -',
        icon: 'TrendingDown',
        color: 'error',
        bgColor: 'bg-error-100',
        textColor: 'text-error-700'
      }
    };
    return configs[type] || configs.adjustment;
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getReasonLabel = (reason) => {
    const reasons = {
      inventory_count: 'Recuento de inventario',
      sale: 'Venta',
      supplier_delivery: 'Entrega de proveedor',
      damaged_goods: 'Mercancía dañada',
      internal_use: 'Uso interno',
      manual_adjustment: 'Ajuste manual',
      return: 'Devolución'
    };
    return reasons[reason] || reason;
  };

  return (
    <div className="bg-surface rounded-lg border border-border h-full flex flex-col">
      {/* Header */}
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Button
              variant="secondary"
              onClick={onBack}
              iconName="ArrowLeft"
              size="sm"
            >
              Volver
            </Button>
            <div>
              <h2 className="text-lg font-semibold text-text-primary">
                Movimientos de Stock
              </h2>
              <p className="text-sm text-text-secondary">
                Historial de cambios en el inventario
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Movements List */}
      <div className="flex-1 overflow-y-auto">
        {movements.length === 0 ? (
          <div className="p-8 text-center">
            <Icon name="BarChart3" size={48} className="text-text-muted mx-auto mb-4" />
            <p className="text-text-muted">No hay movimientos de stock registrados</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {movements.map((movement) => {
              const typeConfig = getMovementTypeConfig(movement.type);

              return (
                <div key={movement.id} className="p-6 hover:bg-secondary-25">
                  <div className="flex items-start space-x-4">
                    {/* Icon */}
                    <div className={`w-10 h-10 ${typeConfig.bgColor} rounded-lg flex items-center justify-center`}>
                      <Icon 
                        name={typeConfig.icon} 
                        size={20} 
                        className={typeConfig.textColor}
                      />
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center space-x-3">
                          <h4 className="font-medium text-text-primary">
                            {movement.productName || 'Producto desconocido'}
                          </h4>
                          <span
                            className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${typeConfig.bgColor} ${typeConfig.textColor}`}
                          >
                            {typeConfig.label}
                          </span>
                        </div>
                        <div className="text-right">
                          <div className={`text-lg font-semibold ${
                            movement.quantity > 0 ? 'text-success' : 'text-error'
                          }`}>
                            {movement.quantity > 0 ? '+' : ''}{movement.quantity}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                        <div>
                          <span className="text-text-secondary">Motivo:</span>
                          <p className="text-text-primary">
                            {getReasonLabel(movement.reason)}
                          </p>
                        </div>
                        <div>
                          <span className="text-text-secondary">Empleado:</span>
                          <p className="text-text-primary">
                            {movement.employeeName}
                          </p>
                        </div>
                        <div>
                          <span className="text-text-secondary">Fecha:</span>
                          <p className="text-text-primary">
                            {formatDateTime(movement.timestamp)}
                          </p>
                        </div>
                      </div>

                      {movement.notes && (
                        <div className="mt-3">
                          <span className="text-text-secondary text-sm">Notas:</span>
                          <p className="text-text-primary text-sm mt-1">
                            {movement.notes}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default StockMovements;